import { useQueryParam } from 'use-query-params';

export function WeekButton({ date }) {
  const [active, setActiveDate] = useQueryParam("date");
  const current = active || date.today

  return (
    <button
      key={date.appointmentDate}
      onClick={() => setActiveDate(date.appointmentDate)}
      data-today={date.today === date.appointmentDate}
      data-active={current === date.appointmentDate}
      className="flex items-center justify-center w-12 flex-col px-2 py-2 border border-white text-sm rounded-md text-zinc-600 hover:border-scale-500 hover:text-scale-500 hover:shadow-md  data-[active=true]:!text-white data-[active=true]:shadow-md data-[today=true]:text-scale-500 data-[today=true]:font-bold data-[active=true]:border-zinc-200/30 data-[active=true]:bg-scale-500">
      <span className="capitalize">{date.weekDay}</span>
      <span>{date.day}</span>
    </button>
  );
}
